import { Component, EventEmitter, Injector, Input, Output, ViewChild } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Art57Section } from '../../ui/Art57Section/Art57Section';
import { ListColumn, ListDataColumn } from '../../ui/Data/ListColumn';
import { BaseNode } from '../../ui/Node/BaseNode';
import { TreeNodeMeddraLevel } from '../../ui/Node/MeddraNode/ListEntity/TreeNodeMeddraLevel';
import { MeddraService } from '../../service/meddra-service/meddra.service';
import { QueryResultNode } from '../../ui/Node/QueryResultNode';
import { QueryNodeInBox } from '../../ui/Node/WebTraderNode/Query/QueryNodeInBox';
import { DateUtil } from '../../ui/DateUtil';
import { QueryNodeOutBox } from '../../ui/Node/WebTraderNode/Query/QueryNodeOutBox';
import { QueryNodeMessageBox } from '../../ui/Node/WebTraderNode/QueryNodeMessageBox';
import { SectionName } from '../../ui/SectionName';
import { MeddraNode } from '../../ui/Node/MeddraNode/MeddraNode';
import { ItemFinderSearchBarComponent } from './item-finder-search-bar/item-finder-search-bar.component';
import { SimpleSearchListNode } from '../../ui/Node/SimpleSearchListNode';
import { ResultList } from '../../ui/Node/ListEntity/ResultList';
import { MedicinalproductsService } from '../../service/medicinalproducts-service/medicinalproducts.service';
import { WebtraderService } from '../../service/webtrader-service/webtrader.service';
import { LookupGetService } from '../../service/lookup-service/lookup-get.service';
import { Art57NodeList } from '../../ui/Node/Art57Node/Art57NodeList';
import { QueryNodeToEudravigilance } from '../../ui/Node/WebTraderNode/Query/QueryNodeToEudravigilance';
import { QueryNodeFromEudravigilance } from '../../ui/Node/WebTraderNode/Query/QueryNodeFromEudravigilance';
import { Art57NodeUtils } from '../../ui/Node/Art57Node/Art57NodeUtils';
import { TreeNodeMedicinalProductsXevprmMessage } from '../../ui/Node/MedicinalProductsNode/ListEntity/TreeNodeMedicinalProductsXevprmMessage';

@Component({
  selector: 'app-item-finder',
  templateUrl: './item-finder.component.html',
  styleUrl: './item-finder.component.scss'
})
export class ItemFinderComponent {

  @Input() selectedNode: any;
  @Output() doAction = new EventEmitter<any>();
  @Output() selectedNodeChange = new EventEmitter<any>();
  @Output() itemFinderDoubleClick = new EventEmitter<any>();
  @ViewChild('item_finder_search_component') item_finder_search_component!: ItemFinderSearchBarComponent;

  loading = false;
  sortProperty: string = '';
  sortOrder = 1;

  constructor(protected injector: Injector) {
    switch (this.injector.get(Art57Section).selectionSectionName) {
      case SectionName.meddra:
        this.injector.get(MeddraService).loading.subscribe(value => this.loading = value);
        break;
      case SectionName.medicinalproducts:
        this.injector.get(MedicinalproductsService).loading.subscribe(value => this.loading = value);
        break;
      case SectionName.webtrader:
        this.injector.get(WebtraderService).loading.subscribe(value => this.loading = value);
        break;
    }

  }

  displayValue(value: any, dataType: ListDataColumn, lookup: string): string {
    let formatedValue: string = '';
    switch (dataType) {
      case ListDataColumn.DATE:
        formatedValue = DateUtil.getDateFormat(value);
        break;
      case ListDataColumn.DATETIME:
        formatedValue = String(value).includes('*') ? value : DateUtil.getDateTimeFormat(value);
        break;
      case ListDataColumn.YESNODATETIME:
        formatedValue = DateUtil.getYesNoDateTimeFormat(value);
        break;
      case ListDataColumn.VERSIONDATE:
        formatedValue = DateUtil.getDate(value);
        break;
      case ListDataColumn.LOOKUP:
        // modelValue is used to fix the issue where some fields are retrieved from hibernate so this formats the value from codeName and if the value is not retrieved from hibernate they are already retrieve with the raw value.
        const modelValue = value && value.value ? value.value : value;
        formatedValue = String(modelValue).includes('*') ? modelValue : this.injector.get(LookupGetService).retrieveValueFromCache(lookup, modelValue);
        break;
      default:
        formatedValue = value;
    }
    return formatedValue;
  }

  sortBy(column: ListColumn, datasource: any[]) {
    this.sortOrder = column.getSourceName() === this.sortProperty ? (this.sortOrder * -1) : 1;
    this.sortProperty = column.getSourceName();
    datasource.sort((a: any, b: any) => {
      let result = 0;

      if (column.getDataType() === ListDataColumn.DATE || column.getDataType() === ListDataColumn.DATETIME || column.getDataType() === ListDataColumn.YESNODATETIME) {
        const valueA = new Date(a[column.getSourceName()]).getTime(); // Convert to timestamp
        const valueB = new Date(b[column.getSourceName()]).getTime(); // Convert to timestamp
        if (valueA < valueB) {
          result = -1;
        }
        if (valueA > valueB) {
          result = 1;
        }
      } else if (column.getDataType() === ListDataColumn.LOOKUP) {
        const valueA = this.injector.get(LookupGetService).retrieveValueFromCache(column.getLookup()!, a[column.getSourceName()]);
        const valueB = this.injector.get(LookupGetService).retrieveValueFromCache(column.getLookup()!, b[column.getSourceName()]);
        result = String(valueA).localeCompare(String(valueB)); 
      } else {
        const valueA = a[column.getSourceName()];
        const valueB = b[column.getSourceName()];

        if (valueA == null && valueB == null) {
          result = 0;
        } else if (valueA == null) {
          result = -1;
        } else if (valueB == null) {
          result = 1;
        } else if (valueA.toString().toLowerCase() < valueB.toString().toLowerCase()) {
          result = -1;
        } else if (valueA.toString().toLowerCase() > valueB.toString().toLowerCase()) {
          result = 1;
        } else {
          result = 0;
        }

      }
      return result * this.sortOrder;
    });
  }

  select($event: any, selectedNode: any, item: any) {
    // Code for non Meddra Section 
    if (selectedNode instanceof QueryNodeInBox ||
      selectedNode instanceof QueryNodeOutBox ||
      selectedNode instanceof QueryNodeToEudravigilance ||
      selectedNode instanceof QueryNodeFromEudravigilance ||
      selectedNode.parent instanceof ResultList ||
      selectedNode instanceof SimpleSearchListNode ||
      selectedNode instanceof TreeNodeMeddraLevel) {
      if (item.checked) {
        item.checked = !item.checked;
      } else {
        item.checked = $event.target.checked;
      }
    }

  }

  selectNode(node: any) {
    this.selectedNodeChange.emit(node);
  }

  onItemFinderDoubleClick(node: any) {
    switch (this.injector.get(Art57Section).selectionSectionName) {
      case SectionName.meddra:
        this.doAction.emit({ action: 'loadMeddraNode', param: node });
        break;
      case SectionName.webtrader:
        this.itemFinderDoubleClick.emit(node);
        break;
    }
  }

  sortIcon(property: string) {
    if (property === this.sortProperty) {
      return this.sortOrder === 1 ? '↑' : '↓';
    }
    return '';
  }

  getMaxNumberRowsReturned(): number {
    return environment.maxNumberRowsReturned
  }

  getCriteria(): string {
    return this.selectedNode.criteria;
  }

  getChildenNode(item: any): BaseNode {
    let result: any;
    switch (this.injector.get(Art57Section).selectionSectionName) {
      case SectionName.webtrader:
        result = this.selectedNode.data.model.find((i: any) => i === item);
        break;
      case SectionName.meddra:
        result = item;
    }
    return result
  }

  isInboxOutbox(): boolean {
    return this.selectedNode instanceof QueryNodeMessageBox;
  }

  isMeddraHierarchy(): boolean {
    return this.selectedNode instanceof MeddraNode && (!(this.selectedNode instanceof TreeNodeMeddraLevel));
  }

  doubleClickPressed(selectedItem: any) {
    this.itemFinderDoubleClick.emit(selectedItem);
  }

  getDynamicHeight(): string {
    return (this.injector.get(Art57Section).isMeddraSection() || this.injector.get(Art57Section).isMedicinalProductSection()) ? this.isResultNode(this.selectedNode) ? "calc(100vh - 270px)" : "calc(100vh - 315px)" : "calc(100vh - 270px)";
  }

  isResultNode(node: any) {
    return node instanceof QueryResultNode ||
      node instanceof Art57NodeList;
  }

  isTreeNodeMeddraLevel(): boolean {
    return this.selectedNode instanceof TreeNodeMeddraLevel
  }

  isTreeNodeMedicinalProducts(): boolean {
    return this.selectedNode instanceof SimpleSearchListNode;
  }

  showSearchBar(): boolean {

    return (this.isTreeNodeMeddraLevel() || 
            (this.isTreeNodeMedicinalProducts() && 
             ((this.selectedNode instanceof TreeNodeMedicinalProductsXevprmMessage &&
              this.selectedNode.parent == undefined           
              ) || 
              (!(this.selectedNode instanceof TreeNodeMedicinalProductsXevprmMessage)                
              )
             )
            )
          );
  }

  showArrayModel(): boolean {
    let showResults = false;

    if (this.selectedNode.hasOwnProperty('showResults')) {
      showResults = this.selectedNode.showResults;
    }
    return !this.loading && (showResults || this.isResultNode(this.selectedNode) || this.isInboxOutbox());
  }

  showTreeModel(): boolean {
    let showResults = false;

    if (this.selectedNode.hasOwnProperty('showResults')) {
      showResults = this.selectedNode.showResults;
    }
    return !this.loading &&
      (!(this.isResultNode(this.selectedNode)) && (!showResults)) &&
      (this.selectedNode.children.length > 0 && !this.isInboxOutbox());
  }

  showDisclaimer(): boolean {
    return !this.loading && (this.selectedNode.data.model);
  }

  ngOnDestroy() {
  }


}
